import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { getGetLocationsQueryOptions } from "@/shared/api/generated/locations";

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    if (!context.user.isSignedIn) {
      redirect({
        to: "/login/$",
        search: {
          redirect: location.href,
        },
        throw: true,
      });
      return;
    }

    const assignedLocations =
      context.organization.organization?.publicMetadata?.locations;

    const existingLocations = await context.queryClient.ensureQueryData(
      getGetLocationsQueryOptions(),
    );

    const accessibleLocations = existingLocations.data?.filter((location) =>
      assignedLocations?.includes(location.id),
    );

    return {
      locations: accessibleLocations,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
